var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgHandHeartFill(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "currentColor",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "e/icon/other/hand_heart_fill"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Vector"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M13.9999 4.56905C14.0221 3.58221 13.5193 2.71959 12.7779 2.2876C12.1421 1.91713 11.3546 1.88302 10.6673 2.31206C9.98005 1.88302 9.19258 1.91713 8.55678 2.2876C7.81532 2.71959 7.31258 3.58221 7.33472 4.56905C7.36325 5.8416 8.34878 6.87812 9.79092 7.73481C10.0587 7.89381 10.3448 8.07388 10.6673 8.07388C10.9899 8.07388 11.276 7.89381 11.5437 7.73481C12.9859 6.87812 13.9714 5.8416 13.9999 4.56905Z"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M5.59335 8.21814L4.26692 9.04721C4.02645 8.81168 3.69718 8.66648 3.33398 8.66648H2.66732C1.93094 8.66648 1.33398 9.26341 1.33398 9.99981V12.6665C1.33398 13.4028 1.93094 13.9998 2.66732 13.9998H3.33398C3.8275 13.9998 4.2584 13.7317 4.48894 13.3331H5.01922C5.12272 13.3331 5.2248 13.3572 5.31737 13.4035L6.88412 14.1869C7.54712 14.5184 8.30172 14.6194 9.02858 14.4741L11.1682 14.0461C11.461 13.9875 11.7371 13.8641 11.9759 13.685L14.0229 12.1497C14.4286 11.8455 14.6673 11.368 14.6673 10.8609V10.8238C14.6673 9.64334 13.4251 8.87554 12.3692 9.40348C11.9095 9.63334 11.4847 9.98701 11.0571 10.2721C11.3044 9.53008 10.9113 8.70694 10.1306 8.51174L7.65345 7.89248C6.95098 7.71688 6.20735 7.83441 5.59335 8.21814Z"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHandHeartFill);
export default __webpack_public_path__ + "static/media/hand_heart_fill.2ea495687a2917f5982963189b88e92d.svg";
export { ForwardRef as ReactComponent };